module.exports = __webpack_public_path__ + "static/media/briefcase.a2c683af.svg";